module.exports = __webpack_public_path__ + "img/ic_liveness_1.5782b1b5.png";